/// <reference path="../../../../typings/index.d.ts" />
///<reference path="short-cuts.interfaces.ts"/>
///<reference path="short-cuts.module.ts"/>

module Meevo.Components.ShortCuts {
    export interface IAddLabelOptions {
        shortCutKey: keyof ICombinationNames;
        additionalClass?: string;
        isDesktop?: boolean;
    }

    export interface IShortCutHelper {
        addLabel(element: angular.IAugmentedJQuery, options: IAddLabelOptions): void;
    }

    class ShortCutsHelper implements IShortCutHelper {

        static factory() {
            const directive = ($timeout: angular.ITimeoutService,
                               shortKeysListService: IShortCutsListService) => {
                return new ShortCutsHelper($timeout, shortKeysListService);
            };

            directive.$inject = ['$timeout', 'meevo.components.short-cuts.ShortCutsListService'];

            return directive;
        }

        constructor(private $timeout: angular.ITimeoutService,
                    private shortKeysListService: IShortCutsListService) {
        }

        addLabel(element: angular.IAugmentedJQuery, options: IAddLabelOptions) {
            if (!options || !options.shortCutKey) {
                return;
            }
            const item = this.shortKeysListService.get(options.shortCutKey);
            if (!item) {
                return;
            }
            const key: string = item.key.toUpperCase();
            const addClass: string = options.additionalClass;
            const showIcon: boolean = options.isDesktop;

            if (showIcon) {
                const icon = angular.element(`<i class="button-short-cut-icon ${addClass}">${key}</i>`);
                element.css({position: 'relative'});
                this.$timeout(() => element.append(icon), 100);
            }
        }
    }


    angular.module('meevo.components.short-cuts')
        .factory('meevo.components.short-cuts.ShortCutsHelper', ShortCutsHelper.factory());
}
